/*
  <variant-swap>

  Controller element. Renders nothing; place one inside <product-info>.

  On variantChange it re-renders every [data-variant-swap] element inside the
  same <product-info>, taking markup from the section HTML that
  VariantSelects.renderProductInfo() already fetched (?variant=...&section_id=...).
  That response is server-rendered for the requested variant, so variant-level
  metafields resolve correctly with no extra network cost.

  A swap target must ALWAYS render (even when empty) so a variant-only value can
  appear on a product whose initial render had nothing. Liquid adds/omits the
  `hidden` class; this mirrors it, matching the Sku pattern in theme.js.
*/
if (!customElements.get('variant-swap')) {
  customElements.define(
    'variant-swap',
    class VariantSwap extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.productInfo.dataset.originalSection
            ? this.productInfo.dataset.originalSection
            : this.productInfo.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateTargets(event.data.html);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      updateTargets(html) {
        /*
          HACK(quick-view): templates/product.quick-view.json also uses the
          section key "main", so sectionId alone can match a different product's
          section. Confirm the fetched section belongs to this product first.
        */
        const fetchedInfo = html.querySelector('product-info');
        const url = this.productInfo.dataset.url;
        if (fetchedInfo && url && fetchedInfo.dataset.url !== url) return;

        this.productInfo.querySelectorAll('[data-variant-swap]').forEach((target) => {
          const key = target.dataset.variantSwap;
          if (!key) return;

          const source = html.querySelector(`[data-variant-swap="${key}"]`);
          if (!source) return;

          if (source.innerHTML !== target.innerHTML) {
            target.innerHTML = source.innerHTML;
          }
          target.classList.toggle('hidden', source.classList.contains('hidden'));
        });
      }
    }
  );
}
